import {
  BondExchangeLanding,
  type BondProduct,
} from "@/components/BondExchangeLanding";

// Commercial Bonds — commercial surety (license & permit, court, fidelity).
// No submission flow wired yet, so the CTA renders inert.
const PRODUCTS: BondProduct[] = [
  {
    name: "License & Permit",
    blurb: "Commercial surety",
    status: "coming_soon",
  },
  {
    name: "Court Bonds",
    blurb: "Appeal, probate, and more",
    status: "coming_soon",
  },
  {
    name: "Fidelity",
    blurb: "Employee dishonesty coverage",
    status: "coming_soon",
  },
];

export function CommercialBondPage() {
  return (
    <BondExchangeLanding
      eyebrow="Commercial Bonds"
      title="Commercial surety, same-day service"
      subtitle="License & permit, court, and fidelity bonds for your commercial clients."
      sectionTitle="Commercial bond products"
      products={PRODUCTS}
    />
  );
}
